import * as yup from 'yup';

export const GenderValidator = yup
  .string()
  .customValidation({
    validator: (gender) => ['f', 'm'].indexOf(gender.toLowerCase()) > -1,
    invalid: 'Cinsiyet seçiniz.',
    empty: 'Cinsiyet seçiniz.',
  })
  .required('Cinsiyet seçiniz.');
